<template>
  <div class="main-container order-manage-container">
    <div class="left-nav-content">
      <leftNav :navList="leftNavList" @on-select="handleNavSelect"></leftNav>
    </div>
    <div class="router-view-content">
      <router-view @refreshSetting="refreshSetting"></router-view>
    </div>
  </div>
</template>

<script>
import leftNav from "@/components/leftNav/index.vue";

export default {
  components: {leftNav},
  data() {
    return {
      leftNavList: [
        {
          title: '所有用户',
          name: 'allUser',
          index: 'allUser',
        }, {
          title: '黑名单管理',
          name: 'blacklistManage',
          index: 'blacklistManage',
        }
      ]
    }
  },
  created() {
    this.$router.push({ name: 'allUser' }, () => {})
  },
  methods: {
    handleNavSelect(navItem) {
      this.$router.push({ name: navItem.name },() => {})
    },
    refreshSetting() {}
  }
}
</script>

<style scoped>
.main-container {
  display: flex;

  .router-view-content {
    display: flex;
    flex: 1;
    overflow: hidden;
    background-color: #fff;
    padding: 20px 30px;
  }
}
</style>